import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.Save.IRequest;
type Response = Api.Core.Dealer.Save.IResponse;
type Headers = Api.Core.Dealer.Save.IHeaders;
const url = '/api/DealerManagement/Dealer';
export default async function dealerSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
